import store, { persistor } from './store/store';

/** Roles that have screens in v2. */
const V2_ROLES = ['PROPERTY_MANAGEMENT_HEAD', 'PROPERTY_MANAGER'];

export function hasV2Access(user) {
  return !!user && (user.userRoleCodes || []).some((role) => V2_ROLES.includes(role));
}

/**
 * v2's address. On the same domain, v2 reads v1's login from localStorage by itself.
 * On a different origin (local dev: :3000 → :5173), the token and user are passed once
 * in the URL fragment (#…); v2 stores them and removes them from the address bar.
 */
export function getV2Url() {
  const { authToken, user } = store.getState().auth;
  const target = new URL(process.env.REACT_APP_V2_URL || '/v2/', window.location.origin);

  if (target.origin !== window.location.origin && authToken) {
    const params = new URLSearchParams({ v1_token: authToken });
    if (user) {
      params.set(
        'v1_user',
        JSON.stringify({
          id: user.id,
          email: user.email,
          fullName: user.fullName,
          userRoleCodes: user.userRoleCodes,
        })
      );
    }
    target.hash = params.toString();
  }
  return target.toString();
}

export async function openV2() {
  // Make sure redux-persist has written the session to localStorage before leaving v1
  if (persistor) await persistor.flush();
  window.location.assign(getV2Url());
}

/** Opens v2 in a new browser tab (used by the left menu). */
export function openV2InNewTab() {
  window.open(getV2Url(), '_blank', 'noopener,noreferrer');
}
